<div class="content" [ngStyle]="{'font-size.em': fontSize}">
  <nav class="navbar navbar-fixed-top white-bg" role="navigation" style="margin-bottom: 0">
    <span class="logo-mobile">
      <a (click)="navReunioes()">
        <img src="assets/images/SMG_color.png" alt="Logo SMG" >
      </a>
    </span>
    <h4>{{isActive('pauta')? '': currentTitle}}</h4>
    <div class="nav navbar-top-links navbar-right">
      <button title="Usuário conectado" class="btn dropdown" [matMenuTriggerFor]="menuLogin">
        <img class="img-icon" src="assets/images/svgs/person.svg" alt="icone usuario">
        <div class="info_user nome-user">
          <div class="nome">{{ nomeUsuario }}</div>
          <div class="orgao">{{ orgaoUsuario }}</div>
        </div>
        <img class="expandir img-icon" src="assets/images/svgs/Expandir.svg" alt="Expandir">
      </button>
  
      <mat-menu #menuLogin="matMenu" xPosition="before" class="dropdown-menu animated " role="menu">
        <li >
          <a href="javascript:void(0)" (click)="alterarSenha()" class="dropdown-item">
            <img class="img-icon" src="assets/images/svgs/person.svg" alt="Alterar Senha">Alterar Senha
          </a>
        </li>        
        <li>
          <a href="javascript:void(0)" (click)="vincularSoe()" class="dropdown-item">
            <img class="img-icon" src="assets/images/svgs/key.svg" alt="Vincular SOE">Vincular SOE
          </a>
        </li>
        <li>
          <a (click)="signout()" class="dropdown-item">
            <img class="img-icon" src="assets/images/svgs/sair.svg" alt="Logout"> Sair
          </a>
        </li>
      </mat-menu>
    </div>
  </nav>
  <nav class="tabs-container nav-menu">
    <ul class="nav nav-tabs" role="tablist">
      <li class="system-mini-icon">
        <img src="assets/images/icons/SMG_icon.png" alt="Logo SMG" (click)="navReunioes()" >
      </li>
      <ng-container *ngFor="let item of data">
        <li *ngIf="item.showOnlyInAdm != true || statusAdm == true ">
          <a [class.active]="isActive(item.id)" (click)="navigate(item.id)">
            <span class="icon" *ngIf="item.icon">{{item.icon}} </span>
            <img class="img-icon" *ngIf="item.file" [src]="item.file" type="image/svg+xml">
            {{item.label}}
          </a>
        </li>
      </ng-container>
    </ul>
    <div class="d-flex">
      <button [matMenuTriggerFor]="menu"  class="btn config-button" aria-label="Configurações">
        <span class="icon">settings</span>
      </button>
      <mat-menu #menu="matMenu" xPosition="before">
        <button mat-menu-item (click)="statusFullScreen? closeFullscreen(): openFullscreen()" class="button-menu mb-2">
          <span class="icon me-2">{{statusFullScreen? 'tv_off': 'screenshot_monitor'}}</span>
          <span class="text-button">{{statusFullScreen? 'Desativar Apresentação': 'Ativar Apresentação'}}</span>
        </button>
        <button mat-menu-item (click)="showFilters = true" class="button-menu mb-2">
          <span class="icon me-2">filter_alt</span>
          <span class="text-button">Filtrar</span>
        </button>
        <button mat-menu-item (click)="setStatus()" class="button-menu mb-2">
          <span class="icon me-2">{{statusAdm? 'visibility_off': 'visibility'}}</span>
          <span class="text-button">{{statusAdm? 'Ocultar': 'Ver ocultados'}}</span>
        </button>
        <!-- <button mat-menu-item class="button-menu mb-2" (click)="print()">
          <span class="icon me-2">print</span>
          <span class="text-button">Imprimir</span>
        </button> -->
        <div class="d-flex">
          <button mat-menu-item class="button-menu me-2" (click)="$event.stopPropagation(); setFont(false)">
            <span class="text-button">A-</span>
          </button>
          <button mat-menu-item class="button-menu" (click)="$event.stopPropagation(); setFont(true)">
            <span class="text-button">A+</span>
          </button>
        </div>
      </mat-menu>
      <button class="btn return-button" (click)="voltar()">
        <span class="icon">undo</span>
        <a>Voltar</a>
      </button>
    </div>
  </nav>
  <section class="modulo-reuniao apresentacao">
    <router-outlet></router-outlet>
    <app-apresentacao-filtro *ngIf="showFilters" [id]="id" (closeFilter)="showFilters = false"></app-apresentacao-filtro>
  </section>

</div>